// @core/api/endpoints/secret/get_encryption_key.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EncryptionKeyResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Get encryption key
 * Returns encryption key metadata (type, versions, config). Does not return key material.
 */
export async function GetEncryptionKey(
  engine_id: string,
  key_name: string,
  options?: RequestOptions
): Promise<EncryptionKeyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/transit/keys/:key_name`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  requestPath = requestPath.replace(':key_name', encodeURIComponent(key_name));
  const requestOptions = options;
  return client.get<EncryptionKeyResponse>(requestPath, { ...requestOptions });
}
